<ng-container>
	<base-display [smallLetters]="s()" [bigLetters]="b()" [unit]="unit()" [showScale]="false"></base-display>
</ng-container>